import { createRef } from "react";
// Components
import Transition from "./Transition";
// Styled
import styled from "styled-components";

const Rules = ({ isVisibleRules, setIsVisibleRules }) => {
  const nodeRef = createRef();

  return (
    <Transition in={isVisibleRules} nodeRef={nodeRef} type="fade">
      <RulesStyled ref={nodeRef}>
        <h2>RULES</h2>
        <img src="./images/image-rules.svg" alt="rules" />
        <img
          onClick={() => setIsVisibleRules(false)}
          className="close-icon"
          src="./images/icon-close.svg"
          alt="close rules"
        />
      </RulesStyled>
    </Transition>
  );
};

export default Rules;

const RulesStyled = styled.div`
  background-color: white;
  color: hsl(229, 25%, 31%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4rem 1.5rem;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  h2 {
    font-size: 2rem;
  }
  .close-icon {
    align-self: center;
    cursor: pointer;
    width: 1.5rem;
  }

  @media screen and (min-width: 1024px) {
    box-shadow: 0 10px 100px 20px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    bottom: initial;
    margin: auto;
    padding: 2rem 1.5rem;
    transform: translateY(45%);
    width: 400px;
    h2 {
      text-align: left;
      margin-bottom: 2rem;
    }
    .close-icon {
      position: absolute;
      top: 2.5rem;
      right: 1.5rem;
    }
  }
`;
